var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',_vm._g({class:_vm.classList,attrs:{"elevation":"0","loading":_vm.loading,"height":"37","minWidth":_vm.minWidth,"outlined":"","data-test-id":_vm.testId}},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }